webpackJsonp([24,47],{

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(1114),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default.a
  },
  props: ["item", "trigger"],
  mounted: function mounted() {
    this.getFavourited;
    var self = this;
    window.addEventListener('resize', function () {
      var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if (height <= 452) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '195px'
        };
        return;
      }

      if (height < 670) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '216px'
        };
        return;
      }

      self.resize = {};
    }, false);
  },
  data: function data() {
    return {
      favorited: false,
      seen: false,
      resize: {}
    };
  },
  methods: {
    copyToClipboard: function copyToClipboard(link) {
      var self = this;
      this.$copyText(link).then(function (e) {
        var snackbar = {
          active: true,
          text: 'Link Successfully Copied To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
        setTimeout(function () {
          var snackbar = {
            active: false,
            text: ''
          };
          self.$store.dispatch('triggerSnackbar', snackbar);
        }, 2000);
      }, function (e) {
        var snackbar = {
          active: true,
          text: 'Unable To Copy Link To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
      });
    },
    closeViewEvent: function closeViewEvent() {
      this.$emit("closeModal");
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.item.uid, this.item.uid);

      var self = this;
      self.favorited = true;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      var self = this;
      self.favorited = false;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).set(null);
    },
    getFavourited: function getFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    }
  },
  computed: {
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    dialog: {
      get: function get() {
        if (this.trigger) {
          this.favorited = false;
          this.getFavourited();
        }

        return this.trigger;
      },
      set: function set(val) {
        this.$emit("closeModal");
      }
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    link: function link() {
      var link = "https://".concat(window.location.host, "/events#id=").concat(this.item.eventKey);
      return link;
    }
  }
};

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".event_icon img{width:50px}.event_title span{font-size:20px;color:#fff;line-height:22px}.event_share{float:left;margin:10px 0}.event_share .btn{height:auto}.event_link a{color:#000;text-decoration:none}.event_link a:hover{text-decoration:underline}.share_list{position:absolute;top:0}.share_list a{height:auto;font-size:12px;color:#666}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/events/EventViewModal.vue"],"names":[],"mappings":"AACA,gBACE,UAAW,CACZ,AACD,kBACE,eAAgB,AAChB,WAAa,AACb,gBAAkB,CACnB,AACD,aACE,WAAW,AACX,aAAc,CACf,AACD,kBACE,WAAY,CACb,AACD,cACE,WAAW,AACX,oBAAsB,CACvB,AACD,oBACG,yBAA2B,CAC7B,AACD,YACE,kBAAmB,AACnB,KAAO,CACR,AACD,cACE,YAAY,AACZ,eAAgB,AAChB,UAAY,CACb","file":"EventViewModal.vue","sourcesContent":["\n.event_icon img{\n  width:50px;\n}\n.event_title span{\n  font-size: 20px;\n  color: white;\n  line-height: 22px;\n}\n.event_share{\n  float:left;\n  margin:10px 0;\n}\n.event_share .btn{\n  height:auto;\n}\n.event_link a{\n  color:#000;\n  text-decoration: none;\n}\n.event_link a:hover{\n   text-decoration: underline;\n}\n.share_list{\n  position: absolute;\n  top: 0;\n}\n.share_list a{\n  height:auto;\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("59092817", content, true, {});

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "max-width": "600px",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: ({
      backgroundColor: this.styles.general.theme_color_light
    })
  }, [_c('v-layout', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeViewEvent
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pb-4 mx-2 px-2"
  }, [_c('v-flex', {
    staticClass: "text-xs-center event_icon",
    attrs: {
      "xs2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.logo ? _vm.item.logo : '/static/images/event-icon.png'
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-4 event_title",
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n            RSVP\n          ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1) : _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "28px",
      "link": _vm.link
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-3",
    style: (_vm.resize),
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Description")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description || '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.eventdate)) + " at " + _vm._s(_vm.item.starteventtime) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.location || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("date_range")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname) + " - " + _vm._s(_vm.item.user.jobtitle || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2 event_link",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("link")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.link))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1144),
  /* template */
  __webpack_require__(1233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue___default.a
  },
  props: ['event', 'type'],
  mounted: function mounted() {
    this.getFavourited;
  },
  data: function data() {
    return {
      favorited: false,
      seen: false
    };
  },
  methods: {
    copyToClipboard: function copyToClipboard(link) {
      var self = this;
      this.$copyText(link).then(function (e) {
        var snackbar = {
          active: true,
          text: 'Link Successfully Copied To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
        setTimeout(function () {
          var snackbar = {
            active: false,
            text: ''
          };
          self.$store.dispatch('triggerSnackbar', snackbar);
        }, 2000);
      }, function (e) {
        var snackbar = {
          active: true,
          text: 'Unable To Copy Link To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
      });
    },
    viewEvent: function viewEvent(event) {
      this.$emit('viewEvent', event);
    },
    showlistTrigger: function showlistTrigger() {
      self = this;
      self.showlist = true;
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = {
        uid: this.userDetails.uid
      };
      var self = this;
      self.favorited = true;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      var self = this;
      self.favorited = false;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).set(null);
    }
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    getFavourited: function getFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    },
    link: function link() {
      var link = "https://".concat(window.location.host, "/events#id=").concat(this.event.eventKey);
      return link;
    }
  }
};

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      alert: false,
      datepickermenu: false,
      timepickermenu: false,
      endtimepickermenu: false,
      event: {
        submitdate: null,
        uid: this.$store.getters.getUserDetails.uid,
        title: '',
        starteventtime: null,
        endeventtime: null,
        eventdate: null,
        location: '',
        description: '',
        link: '',
        attatchment1: '',
        attatchment2: '',
        approvalStatus: 0,
        approvaldate: ''
      }
    };
  },
  props: ['trigger'],
  methods: {
    closeDialog: function closeDialog() {
      this.alert = false;
      this.trigger = false;
    },
    save: function save(data) {
      var _this = this;

      var event = this.event;
      event.submitdate = Date.now();
      this.$firebase.database().ref('events').push(event).then( /*#__PURE__*/function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(snap) {
          return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$store.dispatch("sendNotification", {
                    type: "request",
                    action: "events"
                  });

                case 2:
                  self.dialog = false;
                  _this.alert = true;
                  _this.event.title = '';
                  _this.event.starteventtime = '';
                  _this.event.endeventtime = '';
                  _this.event.eventdate = '';
                  _this.event.location = '';
                  _this.event.description = '';
                  _this.event.link = '';

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      document.getElementById('alert-div').style.display = 'block';
    },
    removeAlert: function removeAlert() {
      document.getElementById('alert-div').style.display = 'none';
    }
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  },
  mounted: function mounted() {
    this.alert = false;
  }
};

/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['trigger', 'item'],
  data: function data() {
    return {
      updateAlert: false,
      datepickermenu: false,
      timepickermenu: false,
      endtimepickermenu: false,
      event: {
        title: '',
        starteventtime: null,
        endeventtime: null,
        eventdate: null,
        location: '',
        description: '',
        link: ''
      }
    };
  },
  mounted: function mounted() {
    this.updateAlert = false;
  },
  methods: {
    save: function save() {
      var _this = this;

      var self = this;
      this.$firebase.database().ref('events/' + this.item.postKey).update(this.item, function (error) {
        if (error) {
          return error;
        } else {
          _this.updateAlert = true;
          document.getElementById('alert-div').style.display = 'block';
        }
      });
    },
    closeModal: function closeModal() {
      this.updateAlert = false;
      this.$emit('closeModal', 'openUpdateEventModal');
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    dialog: function dialog() {
      return this.trigger;
    },
    showAlert: function showAlert() {
      return this.updateAlert;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  }
};

/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".share_list{position:absolute;top:0}.layout.wrap{position:relative}.share_list a{height:auto;font-size:12px;color:#666}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/events/EventTimelineComponent.vue"],"names":[],"mappings":"AACA,YACE,kBAAmB,AACnB,KAAO,CACR,AACD,aACE,iBAAmB,CACpB,AACD,cACE,YAAY,AACZ,eAAgB,AAChB,UAAY,CACb","file":"EventTimelineComponent.vue","sourcesContent":["\n.share_list{\n  position: absolute;\n  top: 0;\n}\n.layout.wrap{\n  position: relative;\n}\n.share_list a{\n  height:auto;\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("75b742e1", content, true, {});

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1142),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1143),
  /* template */
  __webpack_require__(1222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "ml-2 event-info",
    staticStyle: {
      "height": "100%",
      "min-height": "150px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "event-image-flex",
    attrs: {
      "xs3": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "15px"
    }
  }, [_c('img', {
    staticClass: "event-image",
    staticStyle: {
      "border-radius": "15px",
      "height": "100px",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.event.logo || '/static/images/event-icon.png'
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "event-content",
    attrs: {
      "xs9": "",
      "sm10": "",
      "md6": "",
      "lg7": "",
      "pl-3": ""
    }
  }, [_c('h5', {
    staticClass: "secondary--text event-name",
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer",
      "font-size": "17px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewEvent(_vm.event)
      }
    }
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('div', {
    staticClass: "event-date date_range"
  }, [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("actualDate")(_vm.event.eventdate)) + " " + _vm._s(_vm._f("formatTime")(_vm.event.starteventtime)) + " - " + _vm._s(_vm._f("formatTime")(_vm.event.endeventtime)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Registration Deadline:")]), _vm._v(" " + _vm._s(_vm.event.deadline || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Fee:")]), _vm._v(" " + _vm._s(_vm.event.fee || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Center:")]), _vm._v(" " + _vm._s(_vm.event.center || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Point of Contact:")]), _vm._v(" " + _vm._s(_vm.event.pointofcontact || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-left": "-13px"
    },
    attrs: {
      "row": "",
      "hidden-md-and-up": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "16px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "xs3": "",
      "sm4": "",
      "md5": "",
      "lg4": "",
      "hidden-sm-and-down": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "40px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-alert', {
    attrs: {
      "color": "success",
      "icon": "check_circle",
      "value": _vm.alert,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n        Event has been saved and submitted for Review\n      ")]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add new Event")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Title",
      "required": "",
      "prepend-icon": "mdi-textbox"
    },
    model: {
      value: (_vm.event.title),
      callback: function($$v) {
        _vm.$set(_vm.event, "title", $$v)
      },
      expression: "event.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenu),
      callback: function($$v) {
        _vm.datepickermenu = $$v
      },
      expression: "datepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Event Date",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.datepickermenu = false
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.menu1.save(_vm.event.eventdate)
        }
      }
    }, [_vm._v("Save")])], 1)]
  ], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.timepickermenu),
      callback: function($$v) {
        _vm.timepickermenu = $$v
      },
      expression: "timepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Start Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.timepickermenu = false
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$refs.menu2.save(_vm.event.starteventtime)
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu3",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endtimepickermenu),
      callback: function($$v) {
        _vm.endtimepickermenu = $$v
      },
      expression: "endtimepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "End Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.endtimepickermenu = false
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$refs.menu3.save(_vm.event.endeventtime)
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Location",
      "required": "",
      "prepend-icon": "mdi-google-maps"
    },
    model: {
      value: (_vm.event.location),
      callback: function($$v) {
        _vm.$set(_vm.event, "location", $$v)
      },
      expression: "event.location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Link",
      "prepend-icon": "link"
    },
    model: {
      value: (_vm.event.link),
      callback: function($$v) {
        _vm.$set(_vm.event, "link", $$v)
      },
      expression: "event.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "required": "",
      "prepend-icon": "mdi-file-document",
      "label": "Event Description"
    },
    model: {
      value: (_vm.event.description),
      callback: function($$v) {
        _vm.$set(_vm.event, "description", $$v)
      },
      expression: "event.description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.alert = false;
        _vm.$emit('closeModal', 'openEventModal')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "blue darken-1",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div ",
    attrs: {
      "xs12": "",
      "md12": "",
      "id": "alert-div"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-alert', {
    attrs: {
      "color": "success",
      "icon": "check_circle",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_vm._v("\n      Event has been updated successfully\n    ")]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Update Events")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Title",
      "required": "",
      "prepend-icon": "mdi-textbox",
      "disabled": this.item.uid !== _vm.user.uid
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.uid !== _vm.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenu),
      callback: function($$v) {
        _vm.datepickermenu = $$v
      },
      expression: "datepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Event Date",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.item, "eventdate", $$v)
      },
      expression: "item.eventdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.datepickermenu = false
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$refs.menu1.save(_vm.item.eventdate)
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.item, "eventdate", $$v)
      },
      expression: "item.eventdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.uid !== _vm.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.timepickermenu),
      callback: function($$v) {
        _vm.timepickermenu = $$v
      },
      expression: "timepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Start Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "starteventtime", $$v)
      },
      expression: "item.starteventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.timepickermenu = false
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$refs.menu2.save(_vm.item.starteventtime)
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "starteventtime", $$v)
      },
      expression: "item.starteventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    ref: "menu3",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.uid !== _vm.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endtimepickermenu),
      callback: function($$v) {
        _vm.endtimepickermenu = $$v
      },
      expression: "endtimepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "End Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "endeventtime", $$v)
      },
      expression: "item.endeventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.endtimepickermenu = false
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$refs.menu3.save(_vm.item.endeventtime)
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "endeventtime", $$v)
      },
      expression: "item.endeventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Location",
      "disabled": this.item.uid !== _vm.user.uid,
      "required": "",
      "prepend-icon": "mdi-google-maps"
    },
    model: {
      value: (_vm.item.location),
      callback: function($$v) {
        _vm.$set(_vm.item, "location", $$v)
      },
      expression: "item.location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Link",
      "disabled": this.item.uid !== _vm.user.uid,
      "prepend-icon": "link"
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "disabled": this.item.uid !== _vm.user.uid,
      "required": "",
      "prepend-icon": "mdi-file-document",
      "label": "Event Description"
    },
    model: {
      value: (_vm.item.description),
      callback: function($$v) {
        _vm.$set(_vm.item, "description", $$v)
      },
      expression: "item.description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "blue darken-1",
      "flat": "",
      "disabled": this.item.uid !== _vm.user.uid
    }
  }, [_vm._v("Update")])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homepage_events_NewEventsModal_vue__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homepage_events_NewEventsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__homepage_events_NewEventsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grouppage_events_EventViewModal_vue__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grouppage_events_EventViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__grouppage_events_EventViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grouppage_events_EventTimelineComponent_vue__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grouppage_events_EventTimelineComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__grouppage_events_EventTimelineComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_homepage_events_UpdateEventsModel_vue__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_homepage_events_UpdateEventsModel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_homepage_events_UpdateEventsModel_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var db = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      dialog: false,
      trigger: false,
      eventModal: false,
      events: [],
      items: [],
      count: 0,
      eventData: '',
      activeTab: null,
      openUpdateEventModal: false,
      counter: 10,
      selected: false
    };
  },
  components: {
    NewEventsModal: __WEBPACK_IMPORTED_MODULE_2__homepage_events_NewEventsModal_vue___default.a,
    EventViewModal: __WEBPACK_IMPORTED_MODULE_3__grouppage_events_EventViewModal_vue___default.a,
    UpdateEventModal: __WEBPACK_IMPORTED_MODULE_5__pages_homepage_events_UpdateEventsModel_vue___default.a,
    EventTimeline: __WEBPACK_IMPORTED_MODULE_4__grouppage_events_EventTimelineComponent_vue___default.a
  },
  firebase: function firebase() {
    return {
      getEvents: db.ref('events')
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    priviledges: function priviledges() {
      return this.$store.getters.getUserPrivileges;
    },
    breakpoint: function breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    sortEvents: function sortEvents() {
      var todayEvents = this.getTodayEvents(this.events);
      var futureEvents = this.getFutureEvents(this.events);
      return todayEvents.concat(futureEvents);
    }
  },
  mounted: function mounted() {
    var id = window.location.hash.substring(1);

    if (id) {
      this.fetchEvent(id.split('=')[1]);
    }

    var payload = {
      meta: {
        'h1': 'Events',
        'title': 'Events',
        'description': 'General Events Page',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload); // const self = this
    // this.$on('togglemodal', (val) => {
    //   this.dialog = val
    // })

    this.$on('closeModal', this.closeModal);
    this.getGroupEventsWithUser();
  },
  methods: {
    getTodayEvents: function getTodayEvents(events) {
      return events.filter(function (event) {
        var momentNow = __WEBPACK_IMPORTED_MODULE_0_moment__();
        var eventDate = __WEBPACK_IMPORTED_MODULE_0_moment__(event.eventdate);

        if (eventDate.diff(momentNow, 'days') === 0) {
          return event;
        }
      });
    },
    getFutureEvents: function getFutureEvents(events) {
      return events.filter(function (event) {
        var momentNow = __WEBPACK_IMPORTED_MODULE_0_moment__();
        var eventDate = __WEBPACK_IMPORTED_MODULE_0_moment__(event.eventdate); // var eventDate = new Date(event.eventdate)
        // if (dateNow.getTime() < eventDate.getTime() && todayDate !== eventDate.getDate()
        //   && todayMonth <= (eventDate.getMonth() + 1)
        //   && todayYear <= eventDate.getFullYear()
        // ) {
        //   return event
        // }

        if (eventDate.diff(momentNow, 'days') > 0) {
          return event;
        }
      });
    },
    closeModal: function closeModal() {
      this.dialog = false;
      this.eventModal = false;
      this.selected = false;
    },
    viewEvent: function viewEvent(item) {
      window.location.hash = "id=".concat(item.eventKey);
      this.eventData = item;

      if (this.user.uid === item.uid) {
        this.openUpdateEventModal = true;
      } else {
        this.eventModal = true;
      }

      this.selected = true;
    },
    eventClick: function eventClick(event, jsEvent, pos) {
      this.viewEvent(event);
    },
    openModal: function openModal() {
      this.dialog = true;
    },
    getGroupEventsWithUser: function getGroupEventsWithUser() {
      var self = this;
      return this.$firebaseRefs.getEvents.orderByChild('approvalStatus').equalTo(1).on('value', function (result) {
        if (result.val()) {
          self.items = [];
          self.feed = [];
          var results = result.val();
          var eventKeys = Object.keys(results);

          var userIds = self._.uniq(eventKeys.map(function (event) {
            return results[event].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          Promise.all(userInfo).then(function (users) {
            users.forEach(function (user) {
              eventKeys.forEach(function (event) {
                if (results[event].uid === user.val().uid) {
                  var item = results[event];
                  item.eventKey = event;
                  item.id = event;
                  item.avatar = user.val().avatar;
                  item.user = {};
                  Object.assign(item.user, user.val() || {});
                  self.items.push(item);
                  self.events = self.items.sort(function (d1, d2) {
                    return new Date(d1.eventdate).getTime() - new Date(d2.eventdate).getTime();
                  });
                }
              });
            });
          });
        } else {
          self.events = [];
        }
      });
    },
    fetchEvent: function fetchEvent(id) {
      var self = this;
      this.$firebase.database().ref("events/".concat(id)).once('value', function (snap) {
        var data = snap.val();
        return self.getUserInfo(data.uid, self.count).then(function (result) {
          data.user = result.val();
          data.avatar = data.user.avatar;
          var event = data;
          event.eventKey = id;
          self.viewEvent(event);
        });
      });
    },
    counterPost: function counterPost() {
      this.counter = this.counter + 10;
    },
    getUserInfo: function getUserInfo(uid, index) {
      return this.$firebase.database().ref('users/' + uid).once('value');
    },
    getCompanyInformation: function getCompanyInformation(cid, index) {
      return this.$firebase.database().ref('companies/' + cid).once('value');
    }
  }
};

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".comp-full-calendar{max-width:none!important;padding:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/EventsView.vue"],"names":[],"mappings":"AACA,oBACI,yBAA2B,AAC3B,mBAAuB,CAC1B","file":"EventsView.vue","sourcesContent":["\n.comp-full-calendar {\n    max-width: none !important;\n    padding: 0px !important\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1397);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("6c9ae4ac", content, true, {});

/***/ }),

/***/ 1694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "events-view",
    staticStyle: {
      "padding-top": "60px",
      "max-width": "1442px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "page-header-body",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md9": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v("\n          Events")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticClass: "page-header-subtext page-subtitle",
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n            Events are great for getting things done and staying in touch with just the people you want.Share photos and videos,\n          have conversations, make plans and more.\n          ")])])])], 1), _vm._v(" "), (_vm.priviledges.events.create_event) ? _c('v-flex', {
    staticClass: "create-event-flex",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white my-4",
    staticStyle: {
      "height": "70px",
      "text-transform": "capitalize",
      "float": "right",
      "font-size": "18px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "small": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm',
      "large": _vm.breakpoint !== 'xs' && _vm.breakpoint !== 'sm'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm',
      "x-large": _vm.breakpoint === 'md' || _vm.breakpoint === 'lg'
    }
  }, [_vm._v("add")]), _vm._v("\n          Create an Event\n        ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('v-tab', {
    key: "tab-1",
    staticClass: "white",
    attrs: {
      "dark": "",
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "16px"
    },
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("my_location")]), _vm._v("\n                Events\n              ")], 1)]), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.sortEvents), function(event, index) {
    return ((index + 1) <= _vm.counter) ? _c('event-timeline', {
      key: event.eventKey,
      attrs: {
        "type": "events",
        "event": event
      },
      on: {
        "viewEvent": _vm.viewEvent
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), (_vm.events.length >= _vm.counter) ? _c('v-flex', {
    staticClass: "load-data-div",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "load-more",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.counterPost()
      }
    }
  }, [_vm._v("Load More")])], 1) : _vm._e(), _vm._v(" "), _c('new-events-modal', {
    attrs: {
      "groupId": "",
      "groupRoute": "",
      "type": "events",
      "trigger": _vm.dialog
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.dialog = $event
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.selected) ? _c('div', [_c('event-view-modal', {
    attrs: {
      "trigger": _vm.eventModal,
      "item": _vm.eventData
    },
    on: {
      "closeModal": _vm.closeModal
    }
  }), _vm._v(" "), _c('update-event-modal', {
    attrs: {
      "trigger": _vm.openUpdateEventModal,
      "item": _vm.eventData
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.openUpdateEventModal = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1486)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1266),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/24.7ec8dbbfd64c6c0e6889.js